import React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'

import { Icons } from '@/components/atoms/Icons/Icons.tsx'
import { StatusPopup, type StatusPopupData } from '@/components/molecules/StatusPopup/StatusPopup.tsx'
import { cn } from '@/lib/utils.ts'

const regionVariants = cva('relative inline-flex items-center justify-center gap-2 px-5 py-2 text-white', {
  variants: {
    state: {
      ok: 'bg-gray-800',
      warning: 'bg-orange-400 text-black *:fill-black',
      error: 'bg-red-800 *:fill-white',
    },
  },
  defaultVariants: {
    state: 'ok',
  },
})

export interface RegionActions {}

export interface RegionData extends VariantProps<typeof regionVariants>, StatusPopupData {
  name: string
}

export interface RegionProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'>, RegionActions, RegionData {}

export const Region = React.forwardRef<HTMLDivElement, RegionProps>(
  ({ className, state = 'ok', name, messageTitle, messageText, statuses, ...props }, ref) => {
    const [hover, setHover] = React.useState(false)

    return (
      <div className="relative">
        <div
          className={cn('h-[49px]', regionVariants({ state, className }))}
          ref={ref}
          {...props}
          onMouseEnter={() => {
            setHover(true)
          }}
          onMouseLeave={() => {
            setHover(false)
          }}>
          {messageText && <Icons.message className="w-5" />}
          <p className="text-base font-bold select-none">{name}</p>
        </div>
        {hover && (
          <StatusPopup
            className="absolute right-0"
            messageTitle={messageTitle}
            messageText={messageText}
            statuses={statuses}
          />
        )}
      </div>
    )
  }
)
